import { useState, useEffect } from "react";
import { getMinutesFromFormattedHours, getFormattedHoursFromMins } from "src/Common/function";
import _ from "lodash";

import TotalTechItem from "./TotalTechItem";

const TotalTimesheet = ({ timesheetData }) => {

  const [totalRegularTime, setTotalRegularTime] = useState(0);
  const [totalTravelTime, setTotalTravelTime] = useState(0);
  const [totalOverTime, setTotalOverTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);

  const [techData, setTechData] = useState([]);

  useEffect(() => {

    let totalRegularTimeMinutes = 0;
    let totalTravelTimeMinutes = 0;
    let totalOverTimeMinutes = 0;

    for (let tech of timesheetData) {
      let technician = _.cloneDeep(tech);

      let regularTimeMinutes = 0;
      let travelTimeMinutes = 0;
      let overTimeMinutes = 0;

      if (tech?.timesheet) {
        for (let i = 0; i < tech.timesheet.length; i++) {
          regularTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].regularTime);
          travelTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].travelTime);
          overTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].overTime);
        }

        technician.regularTime = getFormattedHoursFromMins(regularTimeMinutes);
        technician.travelTime = getFormattedHoursFromMins(travelTimeMinutes);
        technician.overTime = getFormattedHoursFromMins(overTimeMinutes);
      }

      totalRegularTimeMinutes += regularTimeMinutes;
      totalTravelTimeMinutes += travelTimeMinutes;
      totalOverTimeMinutes += overTimeMinutes;

      setTechData(prev => [...prev, technician]);
    }

    setTotalRegularTime(getFormattedHoursFromMins(totalRegularTimeMinutes));
    setTotalTravelTime(getFormattedHoursFromMins(totalTravelTimeMinutes));
    setTotalOverTime(getFormattedHoursFromMins(totalOverTimeMinutes));
    setTotalTime(getFormattedHoursFromMins(totalRegularTimeMinutes + totalTravelTimeMinutes + totalOverTimeMinutes));
  }, [timesheetData]);

  return (
    <div>
      <div className="w-full h-[40px] flex items-center px-3 relative">
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[265px]">REGULAR TIME</p>
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[159px]">TRAVEL TIME</p>
        <p className="font-OpenSansRegular text-[12px] font-[600] text-titleColor absolute right-[60px]">OVER TIME</p>
      </div>
      <div className="overflow-y-auto max-h-[300px]">
        {techData.map((tech) => (
          <TotalTechItem
            key={tech.id}
            tech={tech}
          />
        ))}
      </div>
      <div className="w-full h-[40px] flex items-center px-3 relative bg-[#E5F0FF]">
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute left-[5%]">WO Total:&nbsp;{totalTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[38%]">{totalRegularTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[22%]">{totalTravelTime}</p>
        <p className="font-OpenSansRegular text-[14px] font-[800] text-blueColor absolute right-[9%]">{totalOverTime}</p>
      </div>

    </div>
  );
};

export default TotalTimesheet;